import styled from 'styled-components';
import ReportHeaderSvg from '../../assets/header/report-header.svg';

const ReportHeaderIcon = styled(ReportHeaderSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
    width: ${props => props.width || '2.6rem'};
    height: ${props => props.height || '2.6rem'};
`;

export default ReportHeaderIcon;